<template lang="html">
  <div style="width: 100%; display: flex;flex-direction: row;">
    <v-flex class="pr-1" shrink="20">
      <TestTypePicker light :value="testType" @input="update('testType', $event)" />
    </v-flex>
    <v-flex class="pr-1 pl-1">
      <MachinesPicker light :value="machine" @input="update('machine', $event)" />
    </v-flex>
    <v-flex class="pl-1">
      <DateRangePicker allowLast10 light dialog :value="dateRange" @input="update('dateRange', $event)" />
    </v-flex>
    <v-flex shrink="100" class="pl-2">
      <slot name="actions" />
    </v-flex>
  </div>
</template>

<style lang="scss">

</style>

<script>
import { mapState } from 'vuex'
import MachinesPicker from './MachinesPicker'
import DateRangePicker from './DateRangePicker'
import TestTypePicker from './TestTypePicker'

export default {
  components: {
    DateRangePicker,
    MachinesPicker,
    TestTypePicker
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState('machines', {
      machinesLoading: 'loading'
    }),
    testType () {
      return (this.value && this.value.testType) || null
    },
    dateRange () {
      return (this.value && this.value.dateRange) || null
    },
    machine () {
      return (this.value && this.value.machine) || null
    }
  },
  methods: {
    async update (key, value) {
      this.$emit('input', {
        ...(this.value || {}),
        [key]: value
      })
    }
  }
}
</script>
